
import { Cellstyle, HotCell, IHotCellSettings } from "~app/common/components/hot-doc/hotdoc/cell";
import { ForsorjningskallaAggregat } from "~app/common/models/forsorjningskalla";
import { ForsorjningskallaTyp } from "../../../../common/models/constants";

/* eslint-disable no-bitwise */
export class ForsorjningskallaCell extends HotCell {
    private readonly markup: string;

    constructor(private readonly markupBuilder: () => string, cellSettings: IHotCellSettings) {
        super(Cellstyle.Readonly | Cellstyle.White | Cellstyle.NoRightBorder, cellSettings);
    }

    static create(source: ForsorjningskallaAggregat, cellSettings: IHotCellSettings): ForsorjningskallaCell {
        const buildMarkup = (): string => {
            switch (source.typ) {
                case ForsorjningskallaTyp.Leverantorsorder: {
                    const link = `<a href = "/core/leverantorsorder/${source.leverantorsorderId}"><span data-bs-toggle="tooltip" title="${source.namn}">${source.namn
                        .substring(0, 20).replace(/(\r\n|\n|\r)/gm, "")}</span></a>`;
                    const huvudkod = `<span>${source.huvudkod}</span>`;
                    return `<div>${link}</div><div>${huvudkod}</div>`;
                }
                case ForsorjningskallaTyp.Terminal:
                case ForsorjningskallaTyp.Produktionsomrade:
                    return source.namn;
            }
            return "";
        };

        return new ForsorjningskallaCell(buildMarkup, cellSettings);
    }

    validate(value: any): boolean {
        return false;
    }

    override onDelete(): void { }

    protected genHtml(): string {
        return this.markupBuilder();
    }

    protected applyStyle(td: HTMLTableCellElement, cellProperties: any) {
        super.applyStyle(td, cellProperties);

        td.style.verticalAlign = "middle";
        td.style.textAlign = "left";
    }
}
